var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_9843)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3640_9843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3640_9843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.8V14.5C17.5 14.3667 17.45 14.25 17.35 14.15C17.25 14.05 17.1333 14 17 14C16.8667 14 16.75 14.05 16.65 14.15C16.55 14.25 16.5 14.3667 16.5 14.5V16.8C16.5 16.9333 16.525 17.0583 16.575 17.175C16.625 17.2917 16.7 17.4 16.8 17.5L18.325 19.025C18.425 19.125 18.5417 19.175 18.675 19.175C18.8083 19.175 18.925 19.125 19.025 19.025C19.125 18.925 19.175 18.8083 19.175 18.675C19.175 18.5417 19.125 18.425 19.025 18.325L17.5 16.8ZM17 22C15.6167 22 14.4377 21.5127 13.463 20.538C12.4877 19.5627 12 18.3833 12 17C12 15.6167 12.4877 14.4373 13.463 13.462C14.4377 12.4873 15.6167 12 17 12C18.3833 12 19.5627 12.4873 20.538 13.462C21.5127 14.4373 22 15.6167 22 17C22 18.3833 21.5127 19.5627 20.538 20.538C19.5627 21.5127 18.3833 22 17 22ZM7 8H15C15.2833 8 15.5207 7.904 15.712 7.712C15.904 7.52067 16 7.28333 16 7C16 6.71667 15.904 6.479 15.712 6.287C15.5207 6.09567 15.2833 6 15 6H7C6.71667 6 6.479 6.09567 6.287 6.287C6.09567 6.479 6 6.71667 6 7C6 7.28333 6.09567 7.52067 6.287 7.712C6.479 7.904 6.71667 8 7 8ZM10.675 20H4C3.45 20 2.979 19.8043 2.587 19.413C2.19567 19.021 2 18.55 2 18V4C2 3.45 2.19567 2.979 2.587 2.587C2.979 2.19567 3.45 2 4 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V10.7C19.5167 10.4667 19.0293 10.2917 18.538 10.175C18.046 10.0583 17.5333 10 17 10C16.8167 10 16.646 10.004 16.488 10.012C16.3293 10.0207 16.1667 10.0417 16 10.075C15.85 10.0417 15.6833 10.0207 15.5 10.012C15.3167 10.004 15.15 10 15 10H7C6.71667 10 6.479 10.0957 6.287 10.287C6.09567 10.479 6 10.7167 6 11C6 11.2833 6.09567 11.5207 6.287 11.712C6.479 11.904 6.71667 12 7 12H12.125C11.825 12.2833 11.554 12.5917 11.312 12.925C11.0707 13.2583 10.8583 13.6167 10.675 14H7C6.71667 14 6.479 14.0957 6.287 14.287C6.09567 14.479 6 14.7167 6 15C6 15.2833 6.09567 15.5207 6.287 15.712C6.479 15.904 6.71667 16 7 16H10.075C10.0417 16.1667 10.0207 16.3293 10.012 16.488C10.004 16.646 10 16.8167 10 17C10 17.55 10.05 18.0627 10.15 18.538C10.25 19.0127 10.425 19.5 10.675 20Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_9843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCard);
export default __webpack_public_path__ + "static/media/timeCard.f8c2a4d3fdebf70ebc9c4e32c4e58ca5.svg";
export { ForwardRef as ReactComponent };